import { useState } from "react";
import { imageUrl } from "@/lib/api";

export const PlanetOrb = ({ planet, className = "", glow = true }) => {
  const [failed, setFailed] = useState(false);
  const [c1, c2, c3] = planet.palette?.length ? planet.palette : ["#00F0FF", "#8A2BE2", "#FFC700"];
  const showImage = planet.has_image && !failed;

  return (
    <div className={`relative aspect-square ${className}`} data-testid="planet-orb">
      {glow && (
        <div className="absolute inset-[6%] rounded-full blur-3xl opacity-50"
          style={{ background: `radial-gradient(circle at 40% 40%, ${c1}, ${c2} 60%, transparent 75%)` }} />
      )}
      <div className="absolute inset-0 rounded-full overflow-hidden border border-white/10"
        style={{ boxShadow: `inset -30px -20px 70px rgba(0,0,0,0.75), 0 0 40px ${c1}33` }}>
        {showImage ? (
          <img src={imageUrl(planet.id)} alt={planet.name} onError={() => setFailed(true)}
            className="h-full w-full object-cover scale-[1.02]" data-testid="planet-image" />
        ) : (
          <div className="h-full w-full" data-testid="planet-procedural"
            style={{ background: `radial-gradient(circle at 35% 30%, ${c3} 0%, ${c1} 28%, ${c2} 62%, #05070D 100%)` }}>
            <div className="h-full w-full opacity-40 mix-blend-overlay"
              style={{ background: "repeating-linear-gradient(170deg, rgba(255,255,255,0.12) 0 6px, transparent 6px 22px)" }} />
          </div>
        )}
        <div className="absolute inset-0 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle at 30% 25%, rgba(255,255,255,0.18), transparent 45%)" }} />
      </div>
    </div>
  );
};
